import React, { Component } from 'react';
import carouselImg from "../assets/img/carousel-1.jpg";
import carouselIm from "../assets/img/carousel-2.jpg";
import networkImg from "../assets/img/switch-rack.jpg"
import accessImg from "../assets/img/cctv.jpg"
import cctvImg from "../assets/img/cctv.jpg"
import netappImg from "../assets/img/storage.jpg"
import serverRack from "../assets/img/server-rack.jpg"
//import netappImg from "../assets/img/storage.jpg"

export class Blog extends Component {
    static displayName = Blog.name;

  render() {
    return (
        <div>

            {/*blog top nav section starts here*/}
            <div class="container-fluid bg-primary py-5 bg-header">
                <div class="row py-5">
                    <div class="col-12 pt-lg-5 mt-lg-5 text-center animated zoomIn">
                        <h3 class="text-capitalize text-white animated zoomIn">blogs</h3>
                        <a class="h5 text-capitalize text-white">home</a>
                        <i class="bi bi-chevron-right text-white px-2"></i>
                        <a class="h5 text-capitalize text-white">blog</a>
                    </div>
                </div>
            </div>
            {/*blog top nav section ends here*/}

            {/*main blog starts here*/}
            {/* ================= Recent Projects ================= */}
            <div class="container mt-5 wow fadeInUp" data-wow-delay="0.2s">

                <div class="section-title text-center position-relative pb-3 mb-5 mx-auto">
                    <h3 class="mb-0 text-uppercase fw-bold">Recent Projects</h3>
                    <p>Explore some of our latest installations and ICT infrastructure deployments.</p>
                </div>

                <div id="recentProjectsCarousel" class="carousel slide" data-bs-ride="carousel">

                    <div class="carousel-inner">

                        {/* Slide One */}
                        <div class="carousel-item active">
                            <div class="row g-3">

                                <div class="col-lg-2 col-md-4 col-6">
                                    <div class="card border-0 shadow-sm h-100">
                                        <img src={netappImg} class="card-img-top" alt="NetApp" />
                                        <div class="card-body p-2">
                                            <small class="text-primary fw-bold">Enterprise Storage</small>
                                            <h6 class="mt-2">NetApp Storage Installation</h6>
                                            <small class="text-muted">
                                                <i class="bi bi-calendar-event me-1"></i>May 28, 2025
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-2 col-md-4 col-6">
                                    <div class="card border-0 shadow-sm h-100">
                                        <img src={serverRack} class="card-img-top" alt="VMware" />
                                        <div class="card-body p-2">
                                            <small class="text-primary fw-bold">Virtualization</small>
                                            <h6 class="mt-2">VMware ESXi Cluster</h6>
                                            <small class="text-muted">
                                                <i class="bi bi-calendar-event me-1"></i>May 26, 2025
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-2 col-md-4 col-6">
                                    <div class="card border-0 shadow-sm h-100">
                                        <img src={netappImg} class="card-img-top" alt="Backup" />
                                        <div class="card-body p-2">
                                            <small class="text-primary fw-bold">Backup</small>
                                            <h6 class="mt-2">Backup & Replication</h6>
                                            <small class="text-muted">
                                                <i class="bi bi-calendar-event me-1"></i>May 24, 2025
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-2 col-md-4 col-6">
                                    <div class="card border-0 shadow-sm h-100">
                                        <img src={cctvImg} class="card-img-top" alt="CCTV" />
                                        <div class="card-body p-2">
                                            <small class="text-primary fw-bold">CCTV</small>
                                            <h6 class="mt-2">Surveillance Installation</h6>
                                            <small class="text-muted">
                                                <i class="bi bi-calendar-event me-1"></i>May 22, 2025
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-2 col-md-4 col-6">
                                    <div class="card border-0 shadow-sm h-100">
                                        <img src={accessImg} class="card-img-top" alt="Access Control" />
                                        <div class="card-body p-2">
                                            <small class="text-primary fw-bold">Access Control</small>
                                            <h6 class="mt-2">Biometric Installation</h6>
                                            <small class="text-muted">
                                                <i class="bi bi-calendar-event me-1"></i>May 20, 2025
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-2 col-md-4 col-6">
                                    <div class="card border-0 shadow-sm h-100">
                                        <img src={networkImg} class="card-img-top" alt="Networking" />
                                        <div class="card-body p-2">
                                            <small class="text-primary fw-bold">Networking</small>
                                            <h6 class="mt-2">Structured Cabling</h6>
                                            <small class="text-muted">
                                                <i class="bi bi-calendar-event me-1"></i>May 18, 2025
                                            </small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <button class="carousel-control-prev" type="button"
                        data-bs-target="#recentProjectsCarousel"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon bg-primary rounded-circle p-3"></span>
                    </button>

                    <button class="carousel-control-next" type="button"
                        data-bs-target="#recentProjectsCarousel"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon bg-primary rounded-circle p-3"></span>
                    </button>

                </div>

            </div>
            {/*main blog ends here*/}


      </div>
    );
  }
}
